import { h } from 'preact'
import { route } from 'preact-router'
import * as firebase from 'firebase'
import FirebaseComponent from './FirebaseComponent'
import './UserDetailDisplay.css'

class UserDetailDisplay extends FirebaseComponent {

  constructor() {
    super()
    this.state = {
      email: '',
      firstName: '',
      lastName: '',
      profileImage: ''
    }

    const uid = firebase.auth().currentUser.uid

    firebase.database().ref(`profiles/${uid}`).on('value', snapshot => {
      this.setState(snapshot.val())
    })
  }

  render() {
    return (
      <div>
        <div className="profile-image-section">
          <a onClick={e => { e.preventDefault(); route('/profile') }}><img src={this.state.profileImage} className="profile-image" alt="profile"/></a>
        </div>
        <div className="profile-welcome-message-section">
          <span className="profile-welcome-message">Welcome back</span>
          <br />
          <span className="profile-welcome-name">{this.state.firstName}</span>
        </div>
      </div>
    );
  }
}

export default UserDetailDisplay



// WEBPACK FOOTER //
// ./src/UserDetailDisplay.js